module.exports = __webpack_public_path__ + "static/media/12.806e308e.png";